import React, { useContext, useEffect } from 'react';
import ComponentCard from 'components/ComponentCard';
import { Table, Button } from 'reactstrap';
import TableContext, { TableContextProvider } from 'context/TableContext';
import { numSortAsc, numSortDesc, strSortAsc, strSortDesc } from 'utils/sortUtils';
import PropTypes from 'prop-types';

const TestTableView = () => {
  const products = [
    { id: 2, name: 'Cheese', price: 4.9, stock: 20 },
    { id: 1, name: 'Milk', price: 1.9, stock: 32 },
    { id: 3, name: 'Yoghurt', price: 2.4, stock: 12 },
    { id: 5, name: 'Heavy Cream', price: 3.9, stock: 9 },
    { id: 4, name: 'Butter', price: 0.9, stock: 99 },
    { id: 6, name: 'Sour Cream ', price: 2.9, stock: 86 },
    { id: 7, name: 'Fancy French Cheese 🇫🇷', price: 99, stock: 12 },
  ];

  return (
    <TableContextProvider>
      <ComponentCard title="Testing sorting tables">
        <ProductsTable products={products} />
      </ComponentCard>
    </TableContextProvider>
  );
};

const ProductsTable = ({ products = [] }) => {
  const { rows, cols, sortField, setTableData, setSortField } = useContext(TableContext);

  const colsConfig = [
    { key: 'id', nom: 'ID' },
    { key: 'name', nom: 'Nom' },
    { key: 'price', nom: 'Preu' },
    { key: 'stock', nom: 'Stock' },
  ];

  const sortFunc = (colKey, order) => {
    switch (colKey) {
      case 'price':
      case 'id':
        return order === 'asc' ? numSortAsc : numSortDesc;
      case 'name':
        return order === 'asc' ? strSortAsc : strSortDesc;
      case 'stock':
        return order === 'asc' ? numSortAsc : numSortDesc;

      default:
        return (a, b) => {
          return 0;
        };
    }
  };

  const sortingValue = (colKey, row) => {
    return row[colKey];
  };

  useEffect(() => {
    setTableData({
      rows: products,
      cols: colsConfig,
      sortingFunc: sortFunc,
      valueFunc: sortingValue,
    });
  }, []);

  const handleColHeaderClick = ({ key }) => {
    const newOrder = sortField.key === key ? (sortField.order === 'asc' ? 'desc' : 'asc') : 'asc';
    setSortField({ key, order: newOrder });
  };

  const tableCols = cols.map((col) => {
    const { nom, key } = col;
    const { key: sortKey, order } = sortField;

    return (
      <th
        className='className="border border-left"'
        scope="col"
        role="button"
        key={key}
        onClick={() => handleColHeaderClick({ key })}
      >
        {nom}
        {key === sortKey ? `${order} x'` : null}
      </th>
    );
  });

  const tableRows = rows.map((row) => {
    const { id, price, name, stock } = row;

    return (
      <tr key={id}>
        <td className="border border-left">{id}</td>
        <td className="border border-left">{name}</td>
        <td className="border border-left">{price}</td>
        <td className="border border-left">{stock}</td>
      </tr>
    );
  });

  return (
    <Table className="border" striped>
      <thead>
        <tr>{tableCols}</tr>
      </thead>
      <tbody>{tableRows}</tbody>
    </Table>
  );
};

ProductsTable.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
};

export default TestTableView;
